export default "__VITE_ASSET__C4zH5wGK__"